// Words used across screens, roles, and the API's fixed error messages.
export const commonEn = {
  'common.interfaceLanguage': 'Interface language',
  'common.save': 'Save',
  'common.saving': 'Saving…',
  'common.cancel': 'Cancel',
  'common.somethingWentWrong': 'Something went wrong',
  'common.requestFailed': 'Request failed ({status})',
  'common.you': '(you)',
  'common.never': 'Never',
  'common.active': 'Active',
  'common.deactivated': 'Deactivated',
  'role.owner': 'Owner',
  'role.support': 'Support',
  'role.billing': 'Billing',
  'apiError.badCredentials': 'Email or password is incorrect',
  'apiError.tooManyAttempts': 'Too many attempts. Try again in 15 minutes.',
  'apiError.captchaFailed': 'The captcha check failed. Try again.',
  'apiError.captchaNotConfigured': 'Sign-in is unavailable: the captcha is not configured',
  'apiError.tooManySignIns': 'Too many sign-in attempts. Try again in a minute.',
  'apiError.signInRequired': 'Sign in required',
  'apiError.sessionExpired': 'Session expired',
  'apiError.crossOrigin': 'Cross-origin request rejected',
  'apiError.someFieldsInvalid': 'Some fields are invalid',
  'apiError.currentPasswordWrong': 'Current password is incorrect',
  'apiError.staffNotFound': 'Staff member not found',
  'apiError.staffEmailExists': 'A staff member with this email already exists',
  'apiError.selfDemote': 'You cannot deactivate or demote yourself',
  'apiError.lastOwner': 'The console needs at least one active owner',
  'apiError.roleNotAllowed': 'Your role does not allow this',
} as const

export const commonId: Record<keyof typeof commonEn, string> = {
  'common.interfaceLanguage': 'Bahasa antarmuka',
  'common.save': 'Simpan',
  'common.saving': 'Menyimpan…',
  'common.cancel': 'Batal',
  'common.somethingWentWrong': 'Terjadi kesalahan',
  'common.requestFailed': 'Permintaan gagal ({status})',
  'common.you': '(Anda)',
  'common.never': 'Belum pernah',
  'common.active': 'Aktif',
  'common.deactivated': 'Nonaktif',
  'role.owner': 'Pemilik',
  'role.support': 'Support',
  'role.billing': 'Penagihan',
  'apiError.badCredentials': 'Email atau kata sandi salah',
  'apiError.tooManyAttempts': 'Terlalu banyak percobaan. Coba lagi dalam 15 menit.',
  'apiError.captchaFailed': 'Cek captcha gagal. Coba lagi.',
  'apiError.captchaNotConfigured': 'Belum bisa masuk: captcha belum diatur',
  'apiError.tooManySignIns': 'Terlalu banyak percobaan masuk. Coba lagi dalam semenit.',
  'apiError.signInRequired': 'Silakan masuk terlebih dahulu',
  'apiError.sessionExpired': 'Sesi telah berakhir',
  'apiError.crossOrigin': 'Permintaan lintas asal ditolak',
  'apiError.someFieldsInvalid': 'Beberapa kolom tidak valid',
  'apiError.currentPasswordWrong': 'Kata sandi saat ini salah',
  'apiError.staffNotFound': 'Staf tidak ditemukan',
  'apiError.staffEmailExists': 'Staf dengan email ini sudah ada',
  'apiError.selfDemote': 'Anda tidak dapat menonaktifkan atau menurunkan peran diri sendiri',
  'apiError.lastOwner': 'Console memerlukan setidaknya satu pemilik aktif',
  'apiError.roleNotAllowed': 'Peran Anda tidak mengizinkan tindakan ini',
}

/** The API's fixed English error messages, by exact text. Anything else is shown as the server sent it. */
export const SERVER_MESSAGE_KEYS: Record<string, keyof typeof commonEn> = {
  'Email or password is incorrect': 'apiError.badCredentials',
  'Too many attempts. Try again in 15 minutes.': 'apiError.tooManyAttempts',
  'The captcha check failed. Try again.': 'apiError.captchaFailed',
  'Sign-in is unavailable: the captcha is not configured': 'apiError.captchaNotConfigured',
  'Too many sign-in attempts. Try again in a minute.': 'apiError.tooManySignIns',
  'Sign in required': 'apiError.signInRequired',
  'Session expired': 'apiError.sessionExpired',
  'Cross-origin request rejected': 'apiError.crossOrigin',
  'Some fields are invalid': 'apiError.someFieldsInvalid',
  'Current password is incorrect': 'apiError.currentPasswordWrong',
  'Staff member not found': 'apiError.staffNotFound',
  'A staff member with this email already exists': 'apiError.staffEmailExists',
  'You cannot deactivate or demote yourself': 'apiError.selfDemote',
  'The console needs at least one active owner': 'apiError.lastOwner',
  'Your role does not allow this': 'apiError.roleNotAllowed',
}
